import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, X, Mail } from 'lucide-react'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()

  const navigation = [
    { name: 'Strona główna', href: '/' },
    { name: 'O firmie', href: '/about' },
    { name: 'Usługi', href: '/services' },
    { name: 'Cennik', href: '/pricing' },
    { name: 'Kontakt', href: '/contact' },
  ]

  const isActive = (path: string) => location.pathname === path

  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-slate-100 sticky top-0 z-50 transition-all duration-300">
      <div className="container-max px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-11 h-11 bg-gradient-to-br from-primary-600 via-primary-700 to-secondary-500 rounded-xl flex items-center justify-center shadow-md shadow-primary-600/15 group-hover:scale-105 transition-transform duration-300">
              <span className="text-white font-extrabold text-lg tracking-wider">FG</span>
            </div>
            <div>
              <h1 className="text-xl font-extrabold text-primary-900 tracking-tight font-display leading-tight">
                FG Falke
              </h1>
              <p className="text-[10px] font-bold text-secondary-600 tracking-wider uppercase leading-tight">
                Transport & Logistyka
              </p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-4 py-2 rounded-xl text-xs font-semibold tracking-wide uppercase transition-all duration-200 ${
                  isActive(item.href)
                    ? 'text-primary-700 bg-primary-50 border border-primary-100/50'
                    : 'text-slate-600 hover:text-primary-700 hover:bg-slate-50/80'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Contact Info Action */}
          <div className="hidden md:flex items-center">
            <Link 
              to="/contact" 
              className="bg-primary-600 hover:bg-primary-700 text-white text-xs font-bold py-2 px-4 rounded-xl shadow-md shadow-primary-600/10 hover:shadow-lg hover:shadow-primary-600/20 active:scale-95 transition-all duration-200 flex items-center space-x-2"
            >
              <Mail className="w-3.5 h-3.5" />
              <span>Napisz do nas</span>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-xl text-slate-600 hover:text-primary-750 hover:bg-slate-50 transition-colors"
          >
            {isMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-slate-100 py-4 animate-in fade-in slide-in-from-top-2 duration-200">
            <nav className="flex flex-col space-y-1.5">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-2.5 rounded-xl text-sm font-semibold tracking-wide uppercase transition-all duration-200 ${
                    isActive(item.href)
                      ? 'text-primary-700 bg-primary-50 border border-primary-100/50'
                      : 'text-slate-600 hover:text-primary-700 hover:bg-slate-50'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="pt-3 mt-1 border-t border-slate-100">
                <Link 
                  to="/contact" 
                  onClick={() => setIsMenuOpen(false)}
                  className="w-full bg-primary-600 text-white text-sm font-bold py-3 px-4 rounded-xl shadow-md hover:bg-primary-700 active:scale-95 transition-all duration-200 flex items-center justify-center space-x-2"
                >
                  <Mail className="w-4 h-4" />
                  <span>Napisz do nas</span>
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  )
}

export default Header
